var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5103_4023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3834 3.32457C14.1834 1.82457 11.4668 2.52457 10.0001 4.24124C8.53343 2.52457 5.81676 1.81624 3.61676 3.32457C2.4501 4.12457 1.71676 5.47457 1.66676 6.89957C1.5501 10.1329 4.41676 12.7246 8.79176 16.6996L8.8751 16.7746C9.50843 17.3496 10.4834 17.3496 11.1168 16.7662L11.2084 16.6829C15.5834 12.7162 18.4418 10.1246 18.3334 6.89124C18.2834 5.47457 17.5501 4.12457 16.3834 3.32457ZM10.0834 15.4579L10.0001 15.5412L9.91676 15.4579C5.9501 11.8662 3.33343 9.49124 3.33343 7.0829C3.33343 5.41624 4.58343 4.16624 6.2501 4.16624C7.53343 4.16624 8.78343 4.99124 9.2251 6.1329H10.7834C11.2168 4.99124 12.4668 4.16624 13.7501 4.16624C15.4168 4.16624 16.6668 5.41624 16.6668 7.0829C16.6668 9.49124 14.0501 11.8662 10.0834 15.4579Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5103_4023",
    x: -2.33667,
    y: -1.50098,
    width: 24.6731,
    height: 22.7061,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5103_4023"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5103_4023",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.d5cf842eb18f4e5395f8d79dbf43e460.svg";
export { ForwardRef as ReactComponent };